<template>
<div class="columns column is-full">
    <div class="column is-one-third">
        <b-field label="EU Settlement status" class="column is-full" :type="{ 'is-danger': hasError('setttlement_status') }" :message="hasError('setttlement_status')">
            <b-select placeholder="Settled / Pre-Settled" v-model="student.applicationInformation.setttlement_status">
                <option v-for="option in euSettlementStatus" :value="option" :key="option">
                    {{ option }}
                </option>
            </b-select>
        </b-field>

        <b-field label="Employment status" class="column is-full" :type="{ 'is-danger': hasError('employment_status') }" :message="hasError('employment_status')">
            <b-select placeholder="Employed / Unemployed / Self-Employed" v-model="student.applicationInformation.employment_status">
                <option v-for="option in employmentStatus" :value="option" :key="option">
                    {{ option }}
                </option>
            </b-select>
        </b-field>

        

        <b-field label="UK Entry Date" class="column is-full" :type="{ 'is-danger': hasError('uk_entry_date') }" :message="hasError('uk_entry_date')">
            <b-datepicker v-model="student.applicationInformation.uk_entry_date" locale="en-GB" :show-week-number="true" icon="calendar-today" :icon-right="student.applicationInformation.uk_entry_date ? 'close-circle' : ''" icon-right-clickable @icon-right-click="clearDate('uk_entry_date')" trap-focus>
            </b-datepicker>
        </b-field>

        <b-field label="Share Code (needs to start with s)" class="column is-full" :type="{ 'is-danger': hasError('share_code') }" :message="hasError('share_code')">
            <b-input v-model="student.applicationInformation.share_code" type="text" name="share_code"></b-input>
        </b-field>
    </div>

    <div class="column is-one-third">
        <b-field label="English qualifications" class="column is-full" :type="{ 'is-danger': hasError('english_qualifications') }" :message="hasError('english_qualifications')">
            <b-radio v-model="student.applicationInformation.english_qualifications" name="name" native-value="Yes">
                Yes
            </b-radio>
            <b-radio v-model="student.applicationInformation.english_qualifications" name="name" native-value="No">
                No
            </b-radio>
        </b-field>

        <b-field v-if="student.applicationInformation.english_qualifications === 'Yes'" label="Type of English qualification" class="column is-full">
            <b-autocomplete open-on-focus rounded v-model="student.applicationInformation.english_exam" :data="filteredEnglishExams" icon="magnify" clearable @select="option => student.applicationInformation.english_exam = option">
                <template #empty>No results found</template>
            </b-autocomplete>
        </b-field>

        <b-field label="Does the student have a diploma?" class="column is-full" :type="{ 'is-danger': hasError('diploma') }" :message="hasError('diploma')">
            <b-radio v-model="student.applicationInformation.diploma" name="diploma" native-value="Yes">
                Yes
            </b-radio>
            <b-radio v-model="student.applicationInformation.diploma" name="diploma" native-value="No">
                No
            </b-radio>
        </b-field>

        <b-field v-if="student.applicationInformation.diploma === 'Yes'" label="What diploma?" class="column is-full">
            <b-input v-model="student.applicationInformation.diploma_type" name="diploma_type" v-validate="{ required: student.applicationInformation.diploma === 'Yes' }" type="text"></b-input>
        </b-field>

        <b-field label="Highest education institution name graduated" class="column is-full"  :type="{ 'is-danger': hasError('education_institution_name') }" :message="hasError('education_institution_name')">
            <b-input placeholder="WRITE THE NAME OF THE LAST INSTITUTION STUDIED BY YOUR STUDENT" v-model="student.applicationInformation.education_institution_name" name="education_institution_name" type="text"></b-input>
        </b-field>

        <b-field label="Route of application" class="column is-full" :type="{ 'is-danger': hasError('application_route') }" :message="hasError('application_route')">
            <b-input placeholder="qualifications/diploma or work experience?" v-model="student.applicationInformation.application_route" name="application_route" type="text"></b-input>
        </b-field>
    </div>

    <div class="column is-one-third">
        <b-field label="Previously applied for Student Finance?" class="column is-full" :type="{ 'is-danger': hasError('studentFinanceApplied') }" :message="hasError('studentFinanceApplied')">
            <b-radio v-model="student.applicationInformation.studentFinanceApplied" name="studentFinanceApplied" native-value="Yes">
                Yes
            </b-radio>
            <b-radio v-model="student.applicationInformation.studentFinanceApplied" name="studentFinanceApplied" native-value="No">
                No
            </b-radio>
        </b-field>

        <b-field v-if="student.applicationInformation.studentFinanceApplied === 'Yes'" label="Type CRN number" class="column is-full">
            <b-input v-model="student.applicationInformation.crn_number" type="text" name="crn_number" v-validate="{ required: student.applicationInformation.studentFinanceApplied === 'Yes' }"></b-input>
        </b-field>

        <b-field v-if="student.applicationInformation.studentFinanceApplied === 'Yes'" label="Date when applied for SFE" class="column is-full">
            <b-datepicker v-model="student.applicationInformation.date_sfe" v-validate="{ required: student.applicationInformation.studentFinanceApplied === 'Yes' }" locale="en-GB" :show-week-number="true" icon="calendar-today" :icon-right="student.applicationInformation.date_sfe ? 'close-circle' : ''" icon-right-clickable @icon-right-click="clearDate('date_sfe')" trap-focus>
            </b-datepicker>
        </b-field>

        <b-field label="NINo number" class="column is-full"  :type="{ 'is-danger': hasError('nino_number') }" :message="hasError('nino_number')">
            <b-input placeholder="if applicable" v-model="student.applicationInformation.nino_number" name="nino_number" type="text"></b-input>
        </b-field>

        <b-field label="Disability" class="column is-full" :type="{ 'is-danger': hasError('disability') }" :message="hasError('disability')">
            <b-radio v-model="student.applicationInformation.disability" name="disability" native-value="Yes">
                Yes
            </b-radio>
            <b-radio v-model="student.applicationInformation.disability" name="disability" native-value="No">
                No
            </b-radio>
        </b-field>

        <b-field v-if="student.applicationInformation.disability === 'Yes'" label="Describe" class="column is-full">
            <b-input v-model="student.applicationInformation.disability_description" type="textarea" name="disability_description"></b-input>
        </b-field>

        <b-field label="Criminal convictions" class="column is-full" :type="{ 'is-danger': hasError('criminal') }" :message="hasError('criminal')">
            <b-radio v-model="student.applicationInformation.criminal" name="criminal" native-value="Yes">
                Yes
            </b-radio>
            <b-radio v-model="student.applicationInformation.criminal" name="criminal" native-value="No">
                No
            </b-radio>
        </b-field>

        <b-field v-if="student.applicationInformation.criminal === 'Yes'" label="Describe" class="column is-full">
            <b-input v-model="student.applicationInformation.criminal_description" type="textarea" name="criminal_description"></b-input>
        </b-field>
    </div>

</div>
</template>

<script>
import {
    euSettlementStatus,
    employmentStatus,
    englishTest
} from '../../models/static'
import moment from 'moment';

export default {
    name: "student-app-info",
    props: ['studentApplcationInformation', 'formErrors'],
    data() {
        return {
            student: {
                applicationInformation: {
                    setttlement_status: '',
                    employment_status: '',
                    uk_entry_date: null,
                    date_sfe: null,
                    share_code: '',
                    english_qualifications: null,
                    english_exam: '',
                    diploma: null,
                    diploma_type: '',
                    studentFinanceApplied: false,
                    crn_number: '',
                    disability: null,
                    disability_description: '',
                    criminal: null,
                    criminal_description: '',
                    application_route: '',
                    nino_number: '',
                    education_institution_name: ''
                },
            },
            euSettlementStatus: [],
            employmentStatus: []
        };
    },
    computed: {
        filteredEnglishExams() {
            return englishTest.filter((option) => {
                return option
                    .toString()
                    .toLowerCase()
                    .indexOf(this.student.applicationInformation.english_exam ? this.student.applicationInformation.english_exam.toLowerCase() : '') >= 0
            })
        },
    },
    watch: {
        student: {
            deep: true,
            handler: function (value) {
                this.$emit('changed', value)
            }
        }
    },
    mounted() {
        let studentApplcationInformation = this.studentApplcationInformation

        this.student.applicationInformation = {
            ...studentApplcationInformation,
            uk_entry_date: studentApplcationInformation  && studentApplcationInformation.uk_entry_date ? this.convertDate(studentApplcationInformation.uk_entry_date) : null,
            date_sfe: studentApplcationInformation && studentApplcationInformation.date_sfe ? this.convertDate(studentApplcationInformation.date_sfe) : null,
        }

        this.euSettlementStatus = euSettlementStatus
        this.employmentStatus = employmentStatus
    },
    methods: {
        clearDate(type) {
            this.student.applicationInformation[type] = null
        },

        convertDate(deadline) {
            if (deadline == null) {
                return deadline
            } else if (new Date(deadline).toString() !== 'Invalid Date') {
                return moment(deadline).toDate()
            } else if (typeof deadline === 'string' || deadline instanceof String) {
                return moment(deadline, "DD-MM-YYYY").toDate()
            }

            return null
        },

        hasError(fieldName) {
            const fieldError = this.formErrors.filter(error => error.fieldName === fieldName)
            return fieldError.length ? fieldError[0].message : null
        }
    }
};
</script>

<style>
.columns {
    flex-wrap: wrap;
}

.tabs li.is-active a,
.tabs li a:hover,
.tabs li.is-active a span {
    text-decoration: none;
}

.custom-autocomplete {
    height: fit-content;
}

.action-buttons {
    justify-content: center;
    display: flex;
}

.action-buttons button {
    margin: 0 10px;
}

.parent-holder {
    margin-bottom: 40px;
}

.card-holder {
    margin-top: 30px;
    margin-left: 0px;
}
</style>
